import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getContracts(params: any): AxiosPromise {
    return EndPointService.get('/contracts', { params });
}
function getContractsDocs(params: any): AxiosPromise {
    return EndPointService.get('/contract_docs', { params });
}

function getContract(id: number | string): AxiosPromise {
    return EndPointService.get(`/contracts/${id}`);
}

function deleteContract(id: number | string): AxiosPromise {
    return EndPointService.delete(`/contracts/${id}`);
}

function createContract(payload: any): AxiosPromise {
    return EndPointService.post('/contracts', payload);
}

function sentToDocusign(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/contracts/status-docusign/${id}`, { ...payload });
}

function remindToDocusign(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/contracts/notify/${id}`, { ...payload });
}

export default {
    getContracts,
    getContract,
    getContractsDocs,
    deleteContract,
    createContract,
    sentToDocusign,
    remindToDocusign,
};
